<div class="cx-one-ui">
    <!-- Parent that resizes with the ngbModal, but the child will have min sizes with overflow scroll -->
    <cv-loader [hidden]="!isLoading" size="large" [overlay]="true"></cv-loader>
    <!-- Header -->
    <div class="modal-header cxone-modal-header">
        <div class="agentStatus cxone-details-header">
            <div class="modal-title cxone-details-title mr-1" cvLocalizedText langSection="Agent_State_Details"
                langKey="CXone_Modal_Title">Agent State Details</div>
            <p class="header-timestamp"> ({{ lastUpdatedTimestamp }}) </p>
        </div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="close()">
                <svg class="icon-12">
                    <use href="../../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>
    <!-- Body Section -->
    <div class="modal-body cxone-modal-body">
        <!-- Top Section -->
        <div class="cxone-details-top">
            <div class="cxone-agent-container">
                <div class="cxoneAgentPicture"><img [attr.src]="agent.profilePicturePath"
                        onerror="this.src='../Admin/ImageResizer.aspx?imgid=-2&w=56&h=56'" /></div>
                <div class="agentName cxone-agent-name">{{ agent.name }}</div>
            </div>
        </div>
        <!-- Bottom Section -->
        <div class="cxone-details-table">
            <!-- Left Table Section -->
            <div class="cxone-state-table">
                <div class="stateHistoryTable currentAgentStatesTableView">
                    <div class="grid-container ag-theme-balham ng-scope">
                        <ag-grid-angular #agentStateDetailGrid *ngIf="gridOptions != null"
                            class="ag-theme-balham flex-fill grid-container" [gridOptions]="gridOptions">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>

            <!-- Summary Right Section -->
            <div class="cxone-state-details">
                <div class="cxone-summary-container">
                    <div class="cxone-summary-title" cvLocalizedText langSection="Agent_State_Details"
                        langKey="CXone_Header_Summary">Summary</div>
                    <div [hidden]="!noData" class="right-error-container">
                        <svg class="error-icon">
                            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
                        </svg>
                        <p class="cxone-error-text" cvLocalizedText langSection="Agent_State_Details"
                            langKey="CXone_Data_Error">No data available</p>
                    </div>
                    <div [hidden]="noData" class="cxone-summary-chart">

                        <!-- Available -->
                        <div class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady"
                                    title="Available"> {{ stateSummary.available.stateName }} </div>
                                <div class="cxone-state-time">{{ stateSummary.available.durationString }}</div>

                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">{{ stateSummary.available.percentage }}%</span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-available"
                                    [progress]="stateSummary.available.percentage"></sol-progress-bar>
                            </div>
                        </div>
                        
                        <!-- Available & Dialler -->
                        <div class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady"
                                    title="Available & Dialler"> {{ stateSummary.availableDialer.stateName }} </div>
                                <div class="cxone-state-time">{{ stateSummary.availableDialer.durationString }}</div>

                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">
                                    {{ stateSummary.availableDialer.percentage }}%
                                </span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-available-dialler"
                                    [progress]="stateSummary.availableDialer.percentage"></sol-progress-bar>
                            </div>
                        </div>

                        <!-- Working Contacts -->
                        <div class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady"
                                    title="Working Contacts">{{ stateSummary.workingContacts.stateName }}</div>
                                <div class="cxone-state-time">{{ stateSummary.workingContacts.durationString }}</div>

                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">
                                    {{ stateSummary.workingContacts.percentage }}%
                                </span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-working-contacts"
                                    [progress]="stateSummary.workingContacts.percentage"></sol-progress-bar>
                            </div>
                        </div>

                        <!-- Working Contacts & Dialler -->
                        <div class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady" title="Working Contacts & Dialler">
                                    {{ stateSummary.workingContactsDialer.stateName }}
                                </div>
                                <div class="cxone-state-time">
                                    {{ stateSummary.workingContactsDialer.durationString }}
                                </div>
                        
                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">
                                    {{ stateSummary.workingContactsDialer.percentage }}%
                                </span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-working-contacts-dialler"
                                    [progress]="stateSummary.workingContactsDialer.percentage"></sol-progress-bar>
                            </div>
                        </div>

                        <!-- Total Unavailable -->
                        <div class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady"
                                    title="Total Unavailable">{{ stateSummary.totalUnavailable.stateName }}</div>
                                <div class="cxone-state-time">{{ stateSummary.totalUnavailable.durationString }}</div>

                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">
                                    {{ stateSummary.totalUnavailable.percentage }}%
                                </span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-total-unavailable"
                                    [progress]="stateSummary.totalUnavailable.percentage"></sol-progress-bar>
                            </div>
                        </div>

                        <!-- Unavailable Substates -->
                        <div *ngFor="let substate of stateSummary.unavailableStates" class="cxone-state-row">
                            <div class="cxone-state-text">
                                <div class="cxone-state-category" [hidden]="!agentStateCategoriesReady"
                                    title="Unavailable Substates">{{ substate.stateName }}</div>
                                <div class="cxone-state-time">{{ substate.durationString }}</div>
                            </div>
                            <div class="cxone-progress-bar-container">
                                <span class="cxone-progress-bar-text">{{ substate.percentage }}%</span>
                                <sol-progress-bar class="cxone-progress-bar cxone-progress-bar-total-unavailable"
                                    [progress]="substate.percentage"></sol-progress-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer cxone-modal-footer">
        <button type="button" class="cxone-btn btn modal-footer-btn btn-primary" cvLocalizedText
            langSection="Agent_State_Details" langKey="Close" (click)="close()">Close</button>
    </div>
</div>